import styled from 'styled-components';

export const RedeemMyGiftStyled = styled.div`
  header nav.navbar > .container-fluid > .container-fluid {
    display: none;
  }
`;